import React, { Component, Fragment, useEffect } from "react";
import { 
    DKButton,
    showToast,
    DKSpinner ,
    TOAST_TYPE,
    showLoader,
    showAlert,
    removeLoader
} from "deskera-ui-library";
import moment from 'moment';
import RouteManager from "../../../managers/RouteManager";
import Table from "../../../services/table";
import {TenantService, TENANT} from '../../../managers/TenantManagerService';
import UserManager from '../../../managers/UserManager';
import { CONSTANTS, DATE_FORMAT, FORMAT } from "../../../constants/Constant";
import Utility from "../../../utility/Utility";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
import ShiftManagementService from "../../../services/ShiftManagementService";
import ShiftUtils from "../../shift_management/ShiftUtils";
import FileUpload from "../FileUpload";
import AttachmentService, { Entity } from "../../../services/AttachmentService";
import { connect, useDispatch } from "react-redux";
import { fetchTeamAttendanceDashbaord } from "../../../Redux/Slices/TeamAttendanceDashboardSlice";
import { isModuleRestricted, MODULE_ACCESS } from "../../module-access-control/ModuleAccessControlConstants";

class AttendanceCard extends Component {
    constructor(props){
        super(props);
        this.state = {
            date: moment().format(FORMAT.DDMMYYYY),
            time: moment().format('hh:mm A'),
            clockTime: {
                clockIn:'',
                clockOut:'',
                status: false
            },
            clockBtnDisable: false,
            workHours:{},
            userName: '',
            isActionInProgress: false,
            shiftName: "",
            attachmentPopup:{
                showPopup: false,
                fileList: []
            },
            shiftName: "",
            loadTeamAttendance: 0
        };
    }
    componentDidMount(){
        this.getAttendanceData();
        if (TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED)) {
            this.getShifts();
        } else {
            this.getTodayWorkweek();
        }
        
        this.intervalID = setInterval(
            () => this.tick(),
            1000
        );
    }
    componentWillUnmount(){
        clearInterval(this.intervalID);
    }
    render(){
        return (
            <>
            {this.getAttendanceCard()}
            {(TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED) && this.state.attachmentPopup?.showPopup )&& this.showUploadPopup()}
            {<TeamAttendanceConnect refresh={this.state.loadTeamAttendance}/>}
            </>
        )
    }
    setAttachmentPopup(visible,type) {
        this.setState({
            loadTeamAttendance: this.state.loadTeamAttendance +1,
            attachmentPopup:{showPopup:visible,type:type}
        })
    }
    tick() {
        this.setState({
            date: moment().format(FORMAT.DDMMYYYY),
            time: moment().format('hh:mm A')
        });
      }
    getAttendanceCard() {
        return (
			<div className="cust-card bg-white p-l mt-l border-radius-m border-m">
				<div className="mt-0 ">
					<h5 className="mt-0 mb-s text-align-left">
						<span className="font-weight-500 fs-xl">Welcome {this.state.userName}</span>
					</h5>
					<span className="font-weight-500  text-align-left text-gray d-flex">
						{this.props.t("ATTENDANCE_CARD_TEXT")}
					</span>
				</div>
				{!isModuleRestricted(this.props.moduleAccessControl, MODULE_ACCESS.ELEAVE) && (
					<div className="d-flex mt-l row row-responsive">
						<div className="pr-l clock-in">
							<p className="mt-s mb-s">
								{Utility.formatDate(this.state.date, FORMAT.DDMMYYYY)},{" "}
								<span className="font-weight-500 fw-m">{this.state.time} </span>{" "}
							</p>
							<div className="row justify-content-center">
								{!this.state.isActionInProgress && !this.state.clockTime.status && (
									<DKButton
										className="text-white bg-app"
										style={{
											"justify-content": "center",
											width: "100%",
										}}
										title="Clock-in"
										onClick={() => this.updateAttendance("CLOCK_IN")}
										disabled={this.state.isActionInProgress}
									/>
								)}
								{!this.state.isActionInProgress && this.state.clockTime.status && (
									<DKButton
										className="bg-red text-white"
										style={{
											"justify-content": "center",
											width: "100%",
										}}
										title="Clock-out"
										onClick={() => this.updateAttendance("CLOCK_OUT")}
										disabled={this.state.isActionInProgress}
									/>
								)}
								{this.state.isActionInProgress && <DKSpinner className={"mt-s"} />}
							</div>
						</div>
						<div className="left-vert-divider">
							<p className="mb-s mt-s text-msg-holder">
								{this.state.clockTime.clockIn !== "" && (
									<span>
										Clock in time{" "}
										{moment(this.state.clockTime.clockIn).format(
											DATE_FORMAT.YYYYMMDD
										)}{" "}
										:{" "}
										<span className="fw-m">
											{moment(this.state.clockTime.clockIn).format("hh:mm A")}
										</span>
									</span>
								)}
								{this.state.clockTime.clockOut !== "" && (
									<Fragment>
										<span className="display-only-web">,&nbsp;</span>{" "}
										<span>
											Clock out time{" "}
											{moment(this.state.clockTime.clockOut).format(
												DATE_FORMAT.YYYYMMDD
											)}{" "}
											:{" "}
											<span class="fw-m">
												{moment(this.state.clockTime.clockOut).format(
													"hh:mm A"
												)}
											</span>
										</span>
									</Fragment>
								)}
								{((this.state.clockTime.clockIn &&
									this.state.clockTime.clockIn !== "") ||
									(this.state.clockTime.clockOut &&
										this.state.clockTime.clockOut !== "")) && (
									<span className="display-only-web">&nbsp;/&nbsp;</span>
								)}
								{this.state.workHours && this.state.workHours.startTime && (
									<span class="text-mute">
										Working hours: {this.state.workHours.startTime} -{" "}
										{this.state.workHours.endTime}{" "}
										{this.state.shiftName ? `(${this.state.shiftName})` : ""}
									</span>
								)}
							</p>

							<DKButton
								style={{
									paddingLeft: "0px",
									paddingRight: "0px",
									width: "fit-content",
								}}
								title={this.props.t("MY_ATTENDANCE_REPORT")}
								className="text-app fw-m"
								onClick={() => {
									RouteManager.navigateToPage("/my-attendance");
								}}
							/>
						</div>
					</div>
				)}
			</div>
		);
    }
    getAttendanceData() {
        let param = {
            limit:1,
            sort: 'updatedOn',
            sortDir: 'desc',
            fromDashboard:true,
            query: `clockIn=${moment().format('YYYY-MM-DD HH:mm')}`
        }
        this.setState({
            isActionInProgress: true
        })
       Table.getAttendance(param).then(
        (response) => {

            let content = response['content'];
            let updated = {
                clockBtnDisable: false,
                clockTime: {
                    clockIn:'',
                    clockOut:'',
                    status: false
                },
                isActionInProgress: false
            }

            if(content.length != 0){
                let selectedContent = content[0];
                updated['clockTime'].clockIn = (selectedContent.clockIn) ? selectedContent.clockIn: '';
                updated['clockTime'].clockOut = (selectedContent.clockOut) ? selectedContent.clockOut: '';
                if(selectedContent.clockIn && selectedContent.clockOut && selectedContent.clockIn !='' && selectedContent.clockOut != '') { // case for Clock in and out is Present
                    updated['clockTime'].status = false; // Status false will show clock In Button
                } else if(selectedContent.clockIn && selectedContent.clockIn !='' && (selectedContent.clockOut == '' || selectedContent.clockOut == null)) { // Clock-In Present but not Clock Out
                    updated['clockTime'].status = true; // Status true will show clock Out Button
                } else if(selectedContent.clockIn && selectedContent.clockOut && selectedContent.clockIn =='' && selectedContent.clockOut == '') {// Both Clock In OUT not present
                    updated['clockTime'].status = false; // Status false will show clock In Button
                }
            }

            this.setState(updated);
            this.getUserDetail();
          },
          (error) => {
            console.log(error)
            this.setState({
                isActionInProgress: false
            })
          }
       )
    }

    async getShifts() {
        ShiftManagementService.getShifts().then(
            (response) => {
                if (Array.isArray(response?.data)) {
                    const userShift = ShiftUtils.getShiftByUserId(TenantService.get(TENANT.USER_ID), response.data);
                    if (userShift) {
                        this.setState({
                            shiftName: userShift.name,
                            workHours: {
                                startTime: moment(userShift.from, "HH:mm").format("hh:mm A"),
                                endTime: moment(userShift.to, "HH:mm").format("hh:mm A")
                            }
                        });
                    } else {
                        this.getTodayWorkweek();
                    }
                }
            }, (error) => {
                this.getTodayWorkweek();
            }
        );
    }

    showUploadPopup = () => {
        return (
            <FileUpload
                isMultiSelect={false}
                onSave={(files) => {
                    this.uploadDocument(files);
                }}
                onClose={() => {
                    this.setState({
                        isActionInProgress:false
                    })
                    this.setAttachmentPopup(false);
                }}
            />
        );
    }
    uploadDocument = (files) => {
        if (files && files[0]) {
            showLoader("Uploading files... Please wait");
            AttachmentService.getUploadFileURL(
                files[files.length - 1].fileContent,
                Entity.PEOPLE_DOCUMENT
            ).then(
                (response) => {
                    if (response?.relativePath) {
                        let formValues = {}
                        formValues['attachments'] = [response.relativePath];
                        this.updateAttendanceAPICall(this.state.attachmentPopup.type,formValues)
                    }
                    showToast("The document is uploaded successfully.", TOAST_TYPE.SUCCESS);
                },
                (error) => {
                    if (error?.status === 500 && error?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
                        showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
                    } else {
                        showToast(i18next.t('SOMETHING_WENT_WRONG'), TOAST_TYPE.FAILURE);
                    }
                }
            ).finally(() => {
                removeLoader();
            });
        }
    }
    updateAttendance(type) {
        let user = UserManager.getUserDetails();
        if((user.imID == TenantService.get(TENANT.IAM_USER_ID) )&& TenantService.get(TENANT.USER_STATUS) === CONSTANTS.INACTIVE) {
            showAlert("Access Denied", "You do not have access to this feature as your access to attendance is restricted.")
            return;
        }
        this.setState({
            isActionInProgress : true
        });
        if((Utility.isEmpty(TenantService.get(TENANT.DATE_OF_JOINING))) || (!moment().isBefore(moment(TenantService.get(TENANT.DATE_OF_JOINING)))) || (moment().isSame(moment(TenantService.get(TENANT.DATE_OF_JOINING)),'day' ))  ) {
            if(TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED)) {
                this.setAttachmentPopup(true,type);
            } else {
                this.updateAttendanceAPICall(type)
            }
        } else {
            if(this.state.clockTime.status) {
                showToast(i18next.t("CLOCK_OUT_DOJ"))
            } else {
                showToast(i18next.t("CLOCK_IN_DOJ"))
            }
        }
    }
    updateAttendanceAPICall(type,attendanceData) {
        let params = {
            punchAt: moment().format('YYYY-MM-DD HH:mm'),
            clockIn:(this.state.clockTime.clockIn && this.state.clockTime.clockIn !='')? moment(this.state.clockTime.clockIn).format('YYYY-MM-DD HH:mm'):moment().format('YYYY-MM-DD HH:mm'),
            type:type,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone     
        }
        if(TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED)) {
            params = {
                ...params,
                ...attendanceData
            }
        }
        Table.attendance(params).then(
            (response) => {
                this.getAttendanceData();
                this.setAttachmentPopup(false);
            },
            (error) => {
                if(error?.errorMessage == "Clock in is too old, contact your admin" || error?.errorMessage?.includes("Exceeded the permitted time for clock out")) {
                    showToast(i18next.t("EXCEED_CLOCK_OUT_TIME"))
                } if(error?.errorMessage?.includes("You are not allowed to clock out for this day as next day shift has already started.")) {
                    showToast("You are not allowed to clock out for this day as next day shift has already started.", TOAST_TYPE.FAILURE);
                }
                this.setState({
                    isActionInProgress : false
                });
            }
        )
    }
    getTodayWorkweek() {
        let tenantData = TenantService.getData()

        let weekDay = moment().format('dddd')
        tenantData[TENANT.TENANT_WORK_WEEK].forEach(day=>{
            if(weekDay.toLowerCase() == day.day.toLowerCase()) {
                this.setState({
                    workHours:day
                })

            }
        })
    }
    getUserDetail() {
        this.setState({userName: UserManager.getUserName()})
    }

}

const mapStateToProps = (state) => ({
    moduleAccessControl: state.moduleAccessControl?.data
});
  
export default connect(mapStateToProps)(withTranslation()(AttendanceCard));

export const TeamAttendanceConnect =(props)=>{
    const dispatch = useDispatch();
    const isAdmin = TenantService.get(TENANT.IS_ADMIN)
    const isManager = TenantService.get(TENANT.IS_MANAGER)
    useEffect(()=>{
        if(props.refresh && (isAdmin || isManager)) {
            getAttendance()
        }
    },[props.refresh])
    const  getAttendance =async()=>{
        await dispatch(fetchTeamAttendanceDashbaord())
    }
    return <></>
}